export function normalizeContractDueDate(value) {
	if (value == null || value === "") return null;
	if (value instanceof Date) {
		return value.toISOString().slice(0, 10);
	}
	const match = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
	return match ? match[1] : null;
}

export function formatContractDueDate(value) {
	const normalized = normalizeContractDueDate(value);
	if (!normalized) return "—";
	const d = new Date(`${normalized}T12:00:00`);
	if (Number.isNaN(d.getTime())) return "—";
	return d.toLocaleDateString("pt-BR");
}
